// pro brand icons (fab)
import { faWpforms } from '@fortawesome/free-brands-svg-icons';

export default (library) => {
    library.add(faWpforms);
};
